import {
  type AppRegion,
  type AppValorantRegion,
  EAppRegions,
} from "@core-types/region.enum";
import type { IRegionStrategy } from "../IRegionStrategy";
import ValorantRegionHelper from "../ValorantRegionHelper";

export class ValorantRegionStrategy implements IRegionStrategy {
  get defaultRegion(): AppRegion {
    return ValorantRegionHelper.DEFAULT_REGION;
  }

  getAllInfo() {
    return ValorantRegionHelper.getAllInfo();
  }

  getInfoByCode(code: AppRegion) {
    return ValorantRegionHelper.getInfoByCode(code as AppValorantRegion);
  }

  getRegionHref(currentPath: string, targetRegionCode: AppRegion): string {
    // Use ALL regions to ensure we strip out any existing region, even if it's from another game
    const regionKeys = Object.values(EAppRegions);
    // Add Valorant specific category slugs here
    const categorySlug = [
      "acheter-compte-valorant",
      "buy-valorant-account",
      // tailored for Valorant
    ];
    const segments = currentPath.split("/").filter(Boolean);

    let finalPath = "";

    for (const segment of segments) {
      // Skip current region name if it exists in the path
      if (regionKeys.includes(segment as any)) {
        continue;
      }

      finalPath += `/${segment}`;

      // Insert target region after category slug
      if (categorySlug.includes(segment)) {
        finalPath += `/${targetRegionCode}`;
      }
    }

    return finalPath || "/";
  }

  convertToRegionEnum(region: string): AppRegion {
    return ValorantRegionHelper.convertToRegionEnum(region);
  }
}
